import React from 'react';
import styled from '@mui/material/styles/styled';
import Box from '../Box';
import Typography from '../Typography';
import Actions from '../Actions';
var PageHeaderRoot = styled(Box)({
    height: '64px',
    display: 'flex',
    alignItems: 'center',
    borderBottom: '1px solid rgba(0, 0, 0, 0.08)'
});
var TitleRender = function (_a) {
    var children = _a.children;
    return (React.createElement(Box, { sx: { flex: 1 } },
        React.createElement(Typography, { variant: 'h6', weight: 'medium' }, children)));
};
var FbmHeader = function (_a) {
    var title = _a.title, actions = _a.actions, renderAction = _a.renderAction;
    var action = null;
    if (typeof renderAction === 'function') {
        action = renderAction();
    }
    else {
        action = React.createElement(Actions, { actions: actions });
    }
    return (React.createElement(PageHeaderRoot, null,
        React.createElement(TitleRender, null,
            " ",
            title,
            " "),
        action));
};
FbmHeader.defaultProps = {
    title: '',
    actions: []
};
export default FbmHeader;
